import { Component, OnInit, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { esLocale } from "ngx-bootstrap/locale";
import { defineLocale } from "ngx-bootstrap/chronos";
import { columnHeader } from "app/shared/factoring-datatable/factoring-datatable.component";
import { AuthService } from "app/core/services/auth/auth.service";
import { AceptantesService } from "app/core/services/factoring/aceptantes.service";
import { ConfirmModalComponent } from "app/shared/utils/confirm-modal/confirm-modal.component";
import { AddArchiveModalComponent } from "../../modals/add-archive-modal/add-archive-modal.component";

@Component({
  selector: "app-add-aceptante-archives",
  templateUrl: "./archives.component.html",
  styleUrls: ["./archives.component.css"],
})
export class ArchivesComponent implements OnInit {
  public user: any;
  public headerTable: columnHeader[];
  public rowData: any[] = [];
  public pageTableActual: number;
  public pageTableTotal: number;
  public pageTablePerPages: number = 10;
  public pageTablePages: number[];
  public searchstring: string = "";

  @Input() aceptanteId = 0;
  @Input() readonly = false;

  constructor(
    private modalService: NgbModal,
    public localeService: BsLocaleService,
    private aceptantesService: AceptantesService,
    private authService: AuthService
  ) {
    defineLocale("es", esLocale);
    this.localeService.use("es");
    this.user = this.authService.user;
  }
  ngOnInit(): void {
    this.initTables();
    this.obtenerArchivos(1, 10);
  }

  async obtenerArchivos(page = 1, page_size: 10) {
    return await this.aceptantesService
      .obtenerArchivos(this.aceptanteId, page, page_size)
      .then((documents: any) => {
        this.loadTable(documents);
      });
  }

  initTables() {
    let headerTable = [
      {
        headerName: "N°",
        field: "index",
        sortable: true,
      },
      {
        headerName: "Nombre del archivo",
        field: "nombre",
        sortable: true,
      },
      {
        headerName: "Usuario",
        field: "usuario_creacion",
        sortable: true,
        class: "text-center",
      },
      {
        headerName: "Fecha de carga",
        field: "fecha_creacion",
        sortable: true,
        pipe: "date",
        class: "text-center",
      },
      {
        headerName: "Última actualización",
        field: "fecha_actualizacion",
        sortable: true,
        pipe: "date",
      },
    ];

    this.headerTable = headerTable;
  }

  loadTable(data) {
    this.rowData = data.results?.map((el: any, i: number) => ({
      ...el,
      index: i + 1,
    }));

    this.pageTableActual = data.page_number;
    this.pageTableTotal = data.count;
    this.pageTablePerPages = data.per_page;
    this.pageTablePages = [];
    for (let index = 0; index < data.num_pages; index++) {
      this.pageTablePages.push(index);
    }
  }

  goToPage({ page, per_page }) {
    this.obtenerArchivos(page, per_page);
  }

  tableEditEvent(archive) {
    const modalRef = this.modalService.open(AddArchiveModalComponent, {
      size: "lg",
    });

    modalRef.componentInstance.aceptanteId = this.aceptanteId;
    modalRef.componentInstance.archiveId = archive.id;

    modalRef.result.then(() => {});

    modalRef.componentInstance.successEmit.subscribe(() => {
      this.obtenerArchivos(1, 10);
    });
  }

  openModal() {
    const modalRef = this.modalService.open(AddArchiveModalComponent, {
      size: "lg",
    });

    modalRef.componentInstance.aceptanteId = this.aceptanteId;

    modalRef.result.then(() => {});

    modalRef.componentInstance.successEmit.subscribe(() => {
      this.obtenerArchivos(1, 10);
    });
  }

  destroyArchive(archive) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {});

    modalRef.componentInstance.title = "Remover Archivo";
    modalRef.componentInstance.message =
      "¿Seguro que desea remover el archivo?";

    modalRef.result.then((result) => {
      if (result) {
        this.aceptantesService
          .eliminarArchivo(archive.id)
          .then(() => {
            this.obtenerArchivos(1, 10);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }
}
